import { render, staticRenderFns } from "./AutomatizacionesPlataformas.vue?vue&type=template&id=7b70edab&scoped=true&"
import script from "./AutomatizacionesPlataformas.vue?vue&type=script&lang=js&"
export * from "./AutomatizacionesPlataformas.vue?vue&type=script&lang=js&"
import style0 from "./AutomatizacionesPlataformas.vue?vue&type=style&index=0&id=7b70edab&prod&lang=scss&"
import style1 from "./AutomatizacionesPlataformas.vue?vue&type=style&index=1&id=7b70edab&prod&scoped=true&lang=css&"
import style2 from "./AutomatizacionesPlataformas.vue?vue&type=style&index=2&id=7b70edab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b70edab",
  null
  
)

export default component.exports